import React from "react";
import { HOMESTAY } from "@/lib/data";

export default function About() {
  return (
    <section
      id="stay"
      data-testid="about-section"
      className="relative bg-mrn-bg py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-5 lg:sticky lg:top-28">
          <p className="text-xs uppercase tracking-[0.3em] text-mrn-terracotta font-medium">
            The Stay
          </p>
          <h2 className="mt-6 headline-display text-4xl md:text-6xl text-mrn-wood">
            An open-brick villa <br />
            <em className="font-light text-mrn-green">at the foot of Nandi.</em>
          </h2>
          <p className="mt-8 text-mrn-wood-soft text-base md:text-lg leading-relaxed max-w-md">
            Our unique villa with a private pond theatre experience is designed
            for slow, memorable getaways. Watch movies under the stars, share
            bonfire stories, BBQ with your mates, and wake up to uninterrupted
            mountain views of Skandagiri, Nandi, Brahmagiri and Chennagiri.
            With a hammock loft, sunrise-facing sit-outs, and play areas for
            sports like cricket and basketball, Mrinmaya is perfect for groups
            looking to relax, reconnect, and experience something different.
          </p>
          <div className="mt-10 grid grid-cols-3 gap-4 max-w-sm">
            <div className="border-l border-mrn-sand-dark pl-4">
              <div className="font-display text-4xl text-mrn-wood">{HOMESTAY.bedrooms}</div>
              <div className="text-xs uppercase tracking-widest text-mrn-wood-soft">Bedrooms</div>
            </div>
            <div className="border-l border-mrn-sand-dark pl-4">
              <div className="font-display text-4xl text-mrn-wood">{HOMESTAY.beds}</div>
              <div className="text-xs uppercase tracking-widest text-mrn-wood-soft">Beds</div>
            </div>
            <div className="border-l border-mrn-sand-dark pl-4">
              <div className="font-display text-4xl text-mrn-wood">{HOMESTAY.sleeps}</div>
              <div className="text-xs uppercase tracking-widest text-mrn-wood-soft">Sleeps</div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-7 grid grid-cols-2 gap-4">
          <img
            src="https://customer-assets.emergentagent.com/job_cozy-nandi-escape/artifacts/e0i228xz_PXL_20260401_124448335~2.jpg"
            alt="Outdoor lounge with swing, koi pond and projector deck at Mrinmaya vacation home"
            className="col-span-2 w-full h-[320px] md:h-[440px] object-cover rounded-2xl"
          />
          <img
            src="https://customer-assets.emergentagent.com/job_cozy-nandi-escape/artifacts/el2soiz8_PXL_20260326_005947734~3.jpg"
            alt="Rooftop dining terrace at sunset, framed by string lights and a glowing sky"
            className="w-full h-56 md:h-72 object-cover rounded-2xl"
          />
          <img
            src="https://customer-assets.emergentagent.com/job_cozy-nandi-escape/artifacts/1zvsus2o_PXL_20260402_125744325~2.jpg"
            alt="Rooftop dining terrace with string lights and orange sunset over Nandi Hills"
            className="w-full h-56 md:h-72 object-cover rounded-2xl"
          />
        </div>
      </div>
    </section>
  );
}
